import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatRow, MatTable, MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { ApiConstants } from 'src/app/constants/api-constants';
import { DataService } from 'src/app/services/data.service';
import { LoaderHandlerService } from 'src/app/services/loader-handler.service';
import { ServicecallService } from 'src/app/services/servicecall.service';
import { SelectionModel } from '@angular/cdk/collections';
import { FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { DtcIdListPopoverComponent } from '../entities/entities-profile/entities-tabs/dtc-id-list-popover/dtc-id-list-popover.component';

export interface Element {
  alertId: string,
  alertDesc: string,
  class: string,
  type: string,
  alertSeverity: string,
  alertCategory: string,
  index: string,
  groupName: string,
  privilege: string,
  menu: string,
  featureName: string,
  featureReleasedOn: string,
  featureId: string,
  featureType: string,
  eventId: string,
  zoneName: string,
  name: string,
  level: string,
  natureDescription: string,
  hierarchyName: string,
  hierarchyNatureDescription: string
}

@Component({
  selector: 'app-common-table',
  templateUrl: './common-table.component.html',
  styleUrls: ['./common-table.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CommonTableComponent implements OnInit, OnChanges, OnDestroy {
  @Input() tableData: any;
  @Input() dataSet: any;
  @Input() columnHeader: any;
  @Input() actionPermission: any;
  @Input() pageType: any;
  @Input() entityDetails: any;
  @Input() noFilter: boolean = false;
  @Input() tabSwitch: boolean;
  @Input() showMultiSelect: boolean;
  @Input() hasStickyHeader: boolean = false;
  @Input() tableTitle: string = "Data";
  @Input() exportRequired: boolean = false;
  @Input() hideNavigation: boolean;
  @Input() caseListPageType: string;
  @Input() hideExport: boolean = false;
  @Input() hideShowRecord : boolean = false;
  @Input() caseType : string;
  @Input() tableHeader: string;
  @Input() releaseAll : boolean = false;
  
  @ViewChild(MatSort, { static: false }) sort!: MatSort;
  @ViewChild(MatPaginator, { static: false }) paginator!: MatPaginator;
  @ViewChildren(MatRow) tableRows!: QueryList<MatRow>;
  @Output() tableAction = new EventEmitter<any>();
  @Output() selectedIds = new EventEmitter<any>();
  @Output() pageSizeChange = new EventEmitter<any>();
  @Output() selectedAlert = new EventEmitter<any>();
  @Output() searchAction = new EventEmitter<any>();
  @Output() showProtusTable = new EventEmitter<any>();
  @Output() tableRendered = new EventEmitter<void>();
  @Output() openPopOver = new EventEmitter<void>();
  @Output() resolveAllEvents = new EventEmitter<any>();

  nonTitleCaseList: any[] = ['attribute', 'values', 'alertId', 'featureId', 'index', 'privilege', 'level', 'hierarchyName', 'hierarchyNatureDescription', 'usersCount', 'attribute.RUL_BRAKE_PAD', 'attribute.RUL_CLUTCH_PAD',
    'deviceName', 'serialNumber', 'entityName', 'deviceType', 'channel', 'interface', 'entityId', 'uniqueId', 'data', 'did', 'tagId', 'taggedTime', 'entryTime', 'exitTime', 'rulValue', 'odometerValue', 'vin',
    'asset', 'location', 'alert', 'frequency', 'segment', 'fuelType', 'entityCategory', 'dtcCode', 'engineNorm', 'engineModel', 'state', 'dtc', 'protusNumber', 'dtcCase', 'acknowledged', 'name', 'caseCategory', 'section', 'dtcDetails', 'Protus Name', 'Project', 'Chassis No', 'entityUniqueId', 'PumpID', 'duId', 'nozzleId', 'TransactionID', 'tankId', 'vehicleChassis', 'time', 'batchId'];
    
  exportincludeList: string[] = ['trlWidget', 'device', 'sites', 'alerts', 'widgetAlerts', 'otherTable', 'widget', 'validOpsTable'];
  loadStatus: boolean = true;
  dataSource = new MatTableDataSource([]);
  error: boolean = false;
  isPaginatorShow: boolean = true;
  selectedIndex: number = null;
  objectKeys = Object.keys;
  pageIndex: number = ApiConstants.global_settings.pageIndex;
  pageSize: number = ApiConstants.global_settings.pageSize;
  pageSizeOptions: any = ApiConstants.global_settings.pageSizeOptions;
  filterLabel: string = 'Attribute/Description/Value/Scope';
  toolTipMessage: any;
  tenantConfig: any;
  selection = new SelectionModel<any>(true, []);
  broadcastSubscription: Subscription;
  allSelect: boolean = false;
  pageSizeLimit: any = [];
  pageSizeFormControl = new FormControl();
  popoverOpen: boolean = false;
  affectedAggregatesList:  { name:string, value: string }[] = [];
  aggregateValue = new FormControl();

  private _subscription: Subscription;
  private _masterSelectedIds: any[] = [];
  private _masterExcludedIds: any[] = [];
  private _idmConfig: any = {};

  constructor(
    private _router: Router,
    private _loaderHandler: LoaderHandlerService,
    public _service: ServicecallService,
    private _datePipe: DatePipe,
    private _dataSer: DataService,
    private _dialog: MatDialog
  ) {
    this._subscription = this._loaderHandler.handler$.subscribe((value) => {
      this.loadStatus = value;
    });
    this.broadcastSubscription = _dataSer.events.subscribe((res: any) => {
      if (res.name === 'timeLineClosed') {
        this.selectedIndex = null;
        this.setDataSource();
      }else if(res.name === 'tabChanged' || res.name === 'updateAlert'){
        this._masterSelectedIds = [];
        this._masterExcludedIds = [];
        this.allSelect = false;   
     }
    });
  }

  ngOnInit(): void {
    const url = this._router.url.split('/');
    this.filterLabel = url[url.length - 1] === 'userGroup' ? 'Index/User Group' : 'All';
    if (this.dataSet) {
      this._filterTable();
    }
    this.isPaginatorShow = this.actionPermission?.pagination === false ? false : true;
    // if (this.isPaginatorShow === false) {
    //   this.pageSize = this.tableData?.length;
    // }
    this.pageSizeLimit = this._service.getConfiguration('pageLimits') ? this._service.getConfiguration('pageLimits')?.pageLimits : [];
    this.toolTipMessage = this._service.getConfiguration('infoMessage') ? this._service.getConfiguration('infoMessage')?.['infoMessage']?.tat : {};
    this.tenantConfig = this._service.getConfiguration('tenantGenericConfig') ? this._service.getConfiguration('tenantGenericConfig') : {};
    this.pageSizeFormControl?.setValue(this.pageSizeLimit?.[0]);
    this._idmConfig = this._service.getConfiguration('idmConfig') ? this._service.getConfiguration('idmConfig') : null;
    const addProtusFieldValues = this._idmConfig ? this._idmConfig?.addProtusFieldValues : null;
    this.affectedAggregatesList = addProtusFieldValues?.affectedAggregates;
  }
  ngOnChanges() {
    if(this.pageType !== 'chart-builder') {
      this.setDataSource();
    }
    if(this.allSelect)
    {
      this.dataSource.data.forEach((elem)=>{
        if(elem.status !== 'Acknowledged' && (this._masterExcludedIds.findIndex((item)=> item.id === elem.id) === -1))
        elem.isSelected = this.allSelect;
      })
    }else{
      for (let i = 0; i < this.dataSource.data.length; i++) {
        if (this._masterSelectedIds.find((elem)=> elem.id === this.dataSource.data[i].id)) {
            this.dataSource.data[i].isSelected = true;
        }
      }
    }  
  }

  ngAfterViewInit() {
    this.setDataSource();
    this.tableRows.changes.subscribe(() => {
      if (this.tableRows.length > 0) {
        this.tableRendered.emit();
      }
    });
  }

  setDataSource() {
    this.dataSource.data = this.tableData;
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
    if (!this.isPaginatorShow) {
      this.pageSize = this.dataSource?.data?.length;
      setTimeout(() => {
        this.dataSource.data = this.tableData;
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      });
    }
  }
  /* Filter functionality */
  applyFilter(event: any) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
    this.pagination(this._getPaginateChange());
  }
  /* Go To page functionality */
  gotoFunctionality(event?: any) {
    const page = (this.paginator.length % this.paginator.pageSize) > 0 ?
      Math.floor(this.paginator.length / this.paginator.pageSize) + 1 : Math.floor(this.paginator.length / this.paginator.pageSize);
    if (event <= page) {
      this.paginator.pageIndex = event - 1;
      // const value: PageEvent = {
      //   length: this.paginator.length,
      //   pageIndex: this.paginator.pageIndex,
      //   pageSize: this.paginator.pageSize
      // };
      // this.paginator.page.next(value);
      this.paginator.page.next(this._getPaginateChange());
      this.error = false;
    } else {
      this.error = true;
    }
  }

  masterToggle() {
    this._masterSelectedIds = [];
    this._masterExcludedIds = [];

    this.allSelect = !this.allSelect;   
      this.dataSource.data.forEach((elem)=>{
        if(elem.status !== 'Acknowledged')
        elem.isSelected = this.allSelect;
      });
  }

  selectedRows(element){
    element.status = element.status === 'Active'? true: false; 
    if(!this.allSelect)
    {
      if(!(this._masterSelectedIds.find((elem)=> elem.id === element.id)))
      {
        this._masterSelectedIds.push(element);
      }else{
        this._masterSelectedIds.splice(this._masterSelectedIds.findIndex((elem)=> elem.id === element.id), 1);
      }
    }else{
      if(!this._masterExcludedIds.find((elem)=> elem.id === element.id))
      {
        this._masterExcludedIds.push(element);
      }else{
        this._masterExcludedIds.splice(this._masterExcludedIds.findIndex((elem)=> elem.id === element.id), 1);
      }
    }
  }

  selectedRowAction(type: string){
    this.selectedIds.emit({type:this.allSelect, action:type, included:this._masterSelectedIds, excluded: this._masterExcludedIds});
  }

  resolveAll(type: string, eventType : string) {
    this.resolveAllEvents.emit({type:true, action:type, eventType: eventType});
  }

  checkIfDisabled()
  {
    if(this.allSelect || this._masterExcludedIds.length || this._masterSelectedIds.length )
    {
      return false;
    }else{
      return true;
    }
  }

  pagination(event: any) {
    let list = document.getElementsByClassName('mat-paginator-range-label');
    let rows;
    if (event) {
      const currentLength = event.length;
      const currentPage = event.pageIndex;
      const currentSize = event.pageSize;
      let from = (currentSize * currentPage) + 1;
      let to = (currentLength < currentSize * (currentPage + 1))
        ? currentLength
        : currentSize * (currentPage + 1);
      let toFrom = (currentLength == 0) ? 0 : `${from} - ${to}`;
      let pageNumber = (currentLength == 0) ? `0 of 0` : `${currentPage + 1} of ${(currentLength % currentSize) > 0 ?
        Math.floor(currentLength / currentSize) + 1 : Math.floor(currentLength / currentSize)}`;
      rows = `Page ${pageNumber} (${toFrom} of ${currentLength})`;
    }
    if (list.length >= 1) {
      list[0].innerHTML = rows ? rows : '';
    }
  }

  onActionClick(row: any, type: string, index: any, isChecked?: boolean) {
    const details = {
      item: row,
      type: type,
      index: index,
      isChecked : isChecked
    };
    this.selectedIndex = index;
    this.tableAction.emit(details);
  }

  exportEvent(event) {
    const details = {
      type: 'export',
      item: event?.fileType,
      classType: event?.classType
    };
    this.tableAction.emit(details);
  }

  validateAction(element: any) {
    if (this.pageType === 'ptw') {
      if (!element['status']) {
        return false;
      } else {
        return true;
      }
    }
    return true;
  }

  navigateTo(elem: any, type: any, dtc?:any) {
    let routerEndpoint = null;
    const trackerDate = this._service.getDateState('tracker')?.date ?? this._service.getDateState('global')?.date ;
    const trackerRange = this._service.getDateState('tracker')?.range ?? this._service.getDateState('global')?.range ;
    const hasTrackerDates = trackerDate?.startDate && trackerDate?.endDate;   
    if (elem.entityType === 'tracker' || elem.entityType === 'alerts' || elem.entityType === 'chartBuilder') {
      if(type === 'entityName' || type === 'name' || type === 'uniqueId') {
        routerEndpoint = elem.entityModule + '/profile/';
      } else if (type === 'dtcCase') {
        const caseDate = this._service.getDateState('case')?.date;
        routerEndpoint = `case/caseList?entityName=${elem?.entityName}`;

        if (hasTrackerDates && elem.entityType === 'tracker') {
          routerEndpoint += `&startDate=${trackerDate.startDate}&endDate=${(trackerRange === 'Yesterday' || trackerRange === 'Custom') ? trackerDate.endDate : new Date()}`;
        }
        routerEndpoint = `case/caseList?entityName=${elem?.entityName}`;
      } else if (type !== 'dtc'){
        routerEndpoint = 'events/alerts/';
      }
    } else if (elem.entityType === 'site') {
      routerEndpoint = type === 'entityName' ? 'plants/profile/' : 'events/alerts/';
    } else if (elem.entityType === 'case') {
      if(type === 'uniqueId') {
        routerEndpoint = elem.entityModule + '/profile/';
      }
    }
    if (type === 'dtc' || type === 'dtcDetails') {
      const navigationExtras: any = {
        queryParams: { pageType: 'caseList' },
      };
      if (this.caseListPageType === 'entityProfile') {
        navigationExtras.state = {
          returnTo: `${elem.entityModule}/profile/${elem.entityId}`,
        };
      }
      type === 'dtc' ? this._router.navigate([`dtc/profile/${elem?.dtcId}`], navigationExtras) : this._router.navigate([`dtc/profile/${dtc?.id}`], navigationExtras);
    } else if (routerEndpoint) {
        if (type !== 'dtcCase') {
          const trackerDate = this._service.getDateState('tracker')?.date ?? this._service.getDateState('global')?.date;
          const trackerRange = this._service.getDateState('tracker')?.range ?? this._service.getDateState('global')?.range;
          const hasTrackerDates = trackerDate?.startDate && trackerDate?.endDate;       

          const queryParams = hasTrackerDates
            ? {
                fromDate: new Date(trackerDate.startDate),
                toDate:( trackerRange === 'Yesterday' || trackerRange === 'Custom') ? new Date(trackerDate.endDate) : new Date(),
                stateRange : trackerRange
              }
            : undefined;        

          this._router.navigate(
            [routerEndpoint + elem.entityId],
            { queryParams }
          );
        } else {
          this._router.navigateByUrl(routerEndpoint);
        }
      }
  }
  setFieldColor(fieldName: string, value: any) {
    let threshold: any;
    if (this.entityDetails) { // Add attributeThreshold-threshold data in 'tenantGenericConfig' configuration in TRL/DMK
      threshold = this._service.getConfigurationBasedOnCategory(this.entityDetails) ?
        this._service.getConfigurationBasedOnCategory(this.entityDetails)?.threshold?.find((elem: any) => elem.name === fieldName) : [];
    } else {
      threshold = this._service.getConfiguration('attributeThreshold')?.threshold?.find((elem: any) => elem.name === fieldName);
    }
    const defaultColors = this._service.getConfiguration('attributeThreshold')?.defaultColorCodes;
    const upperThreshold = threshold?.alertThreshold?.find((elem: any) => elem.name === 'upper')?.threshold;
    const lowerThreshold = threshold?.alertThreshold?.find((elem: any) => elem.name === 'lower')?.threshold;
    if ((+upperThreshold && +value <= +upperThreshold) && (+lowerThreshold && +value >= +lowerThreshold)) {
      return defaultColors?.safe;
    } else if ((+upperThreshold && +value >= +upperThreshold) || (+lowerThreshold && +value <= +lowerThreshold)) {
      return defaultColors?.unsafe;
    } else {
      return '';
    }
  }

  getTitle(key: string, item: any) {
    let returnLabel = '';
    if (key === 'time') {
      if (item?.sourceTimestamp) {
        returnLabel = this._datePipe.transform(item?.sourceTimestamp, 'EEEE, MMMM d, y, h:mm:ss a');
      } else if (item?.processedTime) {
        returnLabel = this._datePipe.transform(item?.processedTime, 'EEEE, MMMM d, y, h:mm:ss a');
      }
      return returnLabel;
    } else if (key === 'attribute.RUL_BRAKE_PAD' || key === 'attribute.RUL_CLUTCH_PAD') {
      returnLabel = this._datePipe.transform(item[key + '_Time'], 'EEEE, MMMM d, y, h:mm:ss a');
      return 'Updated on:' + returnLabel;
    } else
      return item?.[key];
  }

  /**
   * Toggles popover
   * @param dtcDetails 
   */
  togglePopover(details: any, tableData: string) {
    let dialogData;
    if (tableData === 'dtcDetails') {
      dialogData = { details, chipData: details?.dtcDetails, header: 'DTC Ids', navigate: true, id: 'dtcDetails' };
    } else if (tableData === 'engineModel') {
      dialogData = { chipData: details?.['engineModel'], header: 'Engine Model', navigate: false, id: 'engineModel' };
    } else if (tableData === 'emissionNorm') {
      dialogData = { chipData: details?.['emissionNorm'], header: 'Emission Norm', navigate: false, id: 'emissionNorm' };
    }
    this._dialog.open(DtcIdListPopoverComponent, {
      width: '50%',
      disableClose: true,
      data: dialogData
    });
  }

  /**
   * Searchs common table component
   * @param event 
   */
  search(event: any) {
    this.searchAction.emit(event);
  }

  onVirtualScrollValueSelection(option : any) {
    this.aggregateValue.setValue(option?.value);
    if(this.aggregateValue?.value) {
      this.showProtusTable.emit(this.aggregateValue?.value);
    }
  }

  getSelectedOption() {
    this.aggregateValue?.value ? this.affectedAggregatesList?.find(affectedAggregate => affectedAggregate?.value === ((this.aggregateValue?.value))) : null;
  }

  ngOnDestroy(): void {
    this._subscription?.unsubscribe();
    if (this.broadcastSubscription)
      this.broadcastSubscription.unsubscribe();
  }
  private _filterTable() {
    if (this.dataSet == 'alertRule') {
      this.dataSource.filterPredicate = (data: Element, filter: string): boolean => {
        return (
          data.alertId.toLocaleString().includes(filter) ||
          data.alertDesc.toLocaleLowerCase().includes(filter) ||
          data.class.toLocaleLowerCase().includes(filter) ||
          data.type.toLocaleLowerCase().includes(filter) ||
          data.alertSeverity.toLocaleLowerCase().includes(filter) ||
          data.alertCategory.toLocaleLowerCase().includes(filter)
        )
      }
    } else if (this.dataSet == 'feature') {
      this.dataSource.filterPredicate = (data: Element, filter: string): boolean => {
        return (
          data.menu.toLocaleLowerCase().includes(filter) ||
          data.featureName.toLocaleLowerCase().includes(filter) ||
          data.featureReleasedOn.toLocaleString().toLocaleLowerCase().includes(filter) ||
          data.featureId.toLocaleString().includes(filter) ||
          data.featureType.toLocaleLowerCase().includes(filter)
        )
      }
    } else if (this.dataSet == 'userGroup') {
      this.dataSource.filterPredicate = (data: Element, filter: string): boolean => {
        return (
          data.index.toLocaleString().includes(filter) ||
          data.groupName.toLocaleLowerCase().includes(filter)
        )
      }
    } else if (this.dataSet === 'ptw') {
      this.filterLabel = 'Id/Type/Zone';
      this.dataSource.filterPredicate = (data: Element, filter: string): boolean => {
        return (
          data.eventId.toLocaleString().includes(filter) ||
          data.type.toLocaleLowerCase().includes(filter) ||
          data.zoneName.toLocaleLowerCase().includes(filter)
        )
      }
    } else if (this.dataSet == 'zone') {
      this.dataSource.filterPredicate = (data: Element, filter: string): boolean => {
        return (
          data.name.toLocaleLowerCase().includes(filter) ||
          data.level.toLocaleString().includes(filter) ||
          data.natureDescription.toLocaleLowerCase().includes(filter) ||
          data.hierarchyName.toLocaleString().includes(filter) ||
          data.hierarchyNatureDescription.toLocaleString().includes(filter)
        )
      }
    }

  }

  private _getPaginateChange() {
    const value: PageEvent = {
      // length: this.paginator.length,
      length: this.dataSource?.filteredData?.length,
      pageIndex: this.paginator.pageIndex,
      pageSize: this.paginator.pageSize
    };
    return value;
  }

  getSeverityClass(severity: string): string {
    return severity ? severity?.toLocaleLowerCase()?.replace(/\s/g, '-') : '';
  }
  
  /**
   * Pages size limit change
   */
  pageSizeLimitChange() {
    this.pageSizeChange?.emit(this.pageSizeFormControl?.value);
  }

  fetchStateName(state: string) {
   const vehicleStateConfig = this._service.getConfiguration('tenantGenericConfig')?.trackerVehicleStateWidgets ?? [];
   return vehicleStateConfig?.find((item: any) => item?.state === state)?.name;
  }

  getAlerts(row: any) {
    if(this.pageType === 'geoTraceAlert'){
      this.selectedAlert?.emit(row);
    }
  }

  get scalingClass(): string {
    const scale = this._service.getScalingFactor();
    return `dp${scale}`;
  }

  openPreview(tableData : string, row : any) {
    if(tableData === 'scenarioName') {
      this.openPopOver.emit(row)
    }
  }
}
